export const MiamiData = [
  {
    title: "For USCIS Processes",
    detail:
      "Your immmigration needs in and out of Miami are guaranteed by certified USCIS translations. Tomedes' certified translators can translate birth certificates, application forms, ids, passports, and other documents necessary to aid your USCIS applications.",
    link: "/uscis-translation-services",
  },
  {
    title: "For University Applications",
    detail:
      "All types of students who could be in the middle of the university application process can greatly benefit from certified translation services. We ensure that your birth certificates, transcripts, academic records, letters of recommendation, and others are translated into the language of your choice.",
    link: "/transcript-translation-services",
  },
  {
    title: "For Legal Purposes",
    detail:
      "For all legal documents of all types, count on Tomedes to translate them. Our certified translators in Miami are knowledgeable in corporate law, civil law, environmental law, and more. They're versed in the court of law and have experience in the right terminologies.",
    link: "/legal-translation.php",
  },
];

export const LanguagesInMiami = [
  {
    heading: "Spanish",
    detail:
      "The number one language spoken in Miami, Florida, is Spanish. It's spoken at home by 65% of the population, some with limited English proficiency. If you want to reach the Spanish-speaking demographic, Tomedes can help you. Translations in Spanish have never been easier.",
    link: "/spanish-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "One of the key business languages of the world, Chinese is also spoken by 26.4% of the Florida population. Choose Tomedes translators in Miami to translate any of your documents or to localize any of your apps or websites. We'll help make the transition from Chinese to any other language easier.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Japanese",
    detail:
      "Japanese is spoken by 10,012 residents in Florida, and is a popular language of translation for Miami. Adapting Japanese to English or any other language, and vice versa, may help overcome any language barriers in business, in universities, and in organizations. Choose Tomedes translation company today.",
    link: "/japanese-translation.php",
  },
  {
    heading: "Thai",
    detail:
      "Out of Miami's 2.7 bilingual or multilingual speakers, Thai is also spoken largely by the Miami population. Tomedes can bridge the gap between English to Thai and Thai to English or any other languages, through translation. You can communicate much more easily with Miami's Thai demographic then.",
    link: "/thai-translation.php",
  },
];
